import { createContext, useContext } from 'react';
import type {
  CatalogItem,
  CustomerDisplaySettings,
  MenuItem,
  MenuItemDetail,
  MenuRecommendationsPayload,
  PlanFeaturesPayload,
  Restaurant,
  RestaurantCustomerReview,
  RestaurantCustomerReviewSummary,
} from '../services/restaurantService';
import type { GuestOrderingStatus } from '../utils/guestOrdering';

export type PepparSsrKind = 'directory' | 'restaurant' | 'menu' | 'item' | 'reviews' | 'browse';

export interface PepparSsrPayload {
  kind: PepparSsrKind;
  path: string;
  appName?: string;
  itemUrl?: string;
  restaurants?: Restaurant[];
  restaurant?: Restaurant;
  openingHours?: Array<{
    day: string;
    breakfast?: string;
    lunch?: string;
    dinner?: string;
  }>;
  planFeatures?: PlanFeaturesPayload;
  guestOrdering?: GuestOrderingStatus | null;
  displaySettings?: CustomerDisplaySettings | null;
  menuItems?: MenuItem[];
  catalogCategories?: CatalogItem[];
  catalogCuisines?: CatalogItem[];
  menuRecommendations?: MenuRecommendationsPayload | null;
  customerReviews?: RestaurantCustomerReview[];
  customerReviewSummary?: RestaurantCustomerReviewSummary | null;
  categories?: Array<{
    id: number;
    type?: string;
    name?: string;
    iconUrl?: string;
    portraitBannerUrl?: string;
    landscapeBannerUrl?: string;
    displayOrder?: number;
  }>;
  cuisines?: Array<{
    id: number;
    name?: string;
    iconUrl?: string;
    portraitBannerUrl?: string;
    landscapeBannerUrl?: string;
    displayOrder?: number;
  }>;
  menuItem?: MenuItemDetail;
  reviews?: RestaurantCustomerReview[];
}

export const SsrPreloadContext = createContext<PepparSsrPayload | null>(null);

export function useSsrPreload(): PepparSsrPayload | null {
  return useContext(SsrPreloadContext);
}

export function matchSsrPreload(
  preload: PepparSsrPayload | null,
  kind: PepparSsrKind,
  appName?: string,
  itemUrl?: string
): preload is PepparSsrPayload {
  if (!preload || preload.kind !== kind) {
    return false;
  }
  if (appName && preload.appName !== appName) {
    return false;
  }
  if (itemUrl && preload.itemUrl !== itemUrl) {
    return false;
  }
  return true;
}
